/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Od prawej do lewej",
		"timeZoneID": "Strefa czasowa",
		"skin": "Styl",
		"metricsFileImportTask": "Nowy import z plików",
		"displayMode": "Widok domyślny",
		"credentialRenewed": "Odnowiono Twój obecny identyfikator użytkownika i hasło.",
		"productLocale": "Język produktu",
		"toggleDisabled": "wył.",
		"credentialChange": "Odnów",
		"log_level_Debug": "Debugowanie",
		"confirmNewPassword": "Potwierdź nowe hasło",
		"unsavedViewMsg2": "Zmiany zostaną utracone, jeśli nie zostaną najpierw zapisane.",
		"supportPortalErrorMessage": "Spróbuj ponownie.  Jeśli problem będzie się powtarzał, skontaktuj się z administratorem.",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, logo IBM, ibm.com i Cognos są znakami towarowymi lub zastrzeżonymi znakami towarowymi International Business Machines Corp. zarejestrowanymi w wielu systemach prawnych na całym świecie. Aktualna lista znaków towarowych IBM dostępna jest w serwisie WWW, pod adresem www.ibm.com/legal/copytrade.shtml. Program ten jest licencjonowany na warunkach umowy licencyjnej dołączonej do Programu. Umowa taka może znajdować się w katalogu Programu lub w bibliotece, w pliku \"License\" lub \"Non_IBM_License\", bądź też może zostać udostępniona w formie wydruku. Przed użyciem Programu należy dokładnie zapoznać się z treścią umowy licencyjnej. Korzystanie z Programu oznacza zgodę Użytkownika na warunki zawarte w umowie.",
		"groupsAndRoles": "Grupy i role",
		"metricsMaintenanceTask": "Nowa konserwacja",
		"email": "Adres e-mail",
		"contextual": "Kontekstowe",
		"resetHome": "Przywróć wartości domyślne",
		"ltr": "Od lewej do prawej",
		"credentials": "Referencje",
		"logging_congfig_title": "Rejestrowanie",
		"changePasswordTitle": "Zmień moje hasło",
		"format": "Format raportu",
		"showUnread": "Pokaż nieczytane",
		"AILearning_active": "Uczenie sztucznej inteligencji włączone:",
		"docsErrorMessage": "Spróbuj ponownie.  Jeśli problem będzie się powtarzał, skontaktuj się z administratorem.",
		"toggleEnabled": "wł.",
		"homeSetError": "Wystąpił błąd podczas ustawiania domyślnej strony głównej. Spróbuj zamknąć i z powrotem otworzyć ten widok.",
		"passwordChange": "Zmień hasło",
		"profile": "Profil",
		"pdfRestricted": "PDF (z ograniczeniami)",
		"drillThrough": "Definicje drążenia wszerz",
		"homeSet": "Strona główna została ustawiona pomyślnie",
		"regionalOptions": "Opcje regionalne",
		"myPreferences": "Moje preferencje",
		"defaultHome": "Domyślne",
		"version": "Wersja",
		"controller": "Controller",
		"manage": "Zarządzaj",
		"biDirectionalFeaturesEnabled": "Obsługa języków dwukierunkowych",
		"newFeaturesErrorTitle": "Odsyłacz do nowych funkcji nie zadziałał",
		"passwordMatch": "Hasła zgodne",
		"updateProfileAndsettings": "Zmień profil i ustawienia",
		"dashboardConsole": "Obszar roboczy",
		"legacyAppsSlideoutLabel": "Dostępne wcześniejsze aplikacje",
		"logging_config_description": "Rejestrowanie służy do rozwiązywania problemów. Zwróć się do administratora, aby uzyskać wytyczne dotyczące ustawień.",
		"confirmDeletion": "Potwierdź usunięcie",
		"signInButtonText": "Zaloguj się",
		"dataSourceCredentials": "Dane uwierzytelniające serwera danych",
		"AILearningConfigurationSlideoutAllyLabel": "Konfiguracja uczenia sztucznej inteligencji",
		"loadingSettings": "Ładowanie ustawień",
		"spreadsheetMLRestricted": "Excel (z ograniczeniami)",
		"manageAILearning": "Uczenie sztucznej inteligencji",
		"xlsxDataRestricted": "Dane programu Excel (z ograniczeniami)",
		"advanced": "Opcje zaawansowane",
		"ok": "OK",
		"changeEmail": "Zmień",
		"showHints": "Pokaż wskazówki",
		"general": "Ogólne",
		"xlsxData": "Dane programu Excel",
		"newPassword": "Nowe hasło",
		"hideAll": "Ukryj wszystko",
		"confirmPassword": "Potwierdź hasło",
		"AILearning_config_description": "Pozwól programowi Cognos Analytics uczyć się tego, jak go używasz, a będziesz otrzymywać lepsze rekomendacje.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Odsyłacz do portalu wsparcia nie zadziałał",
		"log_level_Warn": "Ostrzeżenie",
		"contentSettings": "Ustawienia treści",
		"setHomeButton": "Ustaw",
		"myCapabilities": "Moje możliwości",
		"homePage": "Strona główna",
		"helpErrorMessage": "Spróbuj ponownie.  Jeśli problem będzie się powtarzał, skontaktuj się z administratorem.",
		"loadingProfile": "Ładowanie profilu",
		"portal": "Portal",
		"metricsPackage": "Nowy pakiet",
		"myCredentials": "Moje dane uwierzytelniające",
		"credentialCreate": "Utwórz",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Nie można zaktualizować hasła",
		"showHiddenObjects": "Pokaż ukryte elementy",
		"csv": "CSV",
		"docsErrorTitle": "Odsyłacz do dokumentacji nie zadziałał",
		"log_level_Error": "Błąd",
		"wrongPassword": "Uwierzytelnienie nie powiodło się",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Informacje",
		"welcomeBanner": "Baner powitalny",
		"helpErrorTitle": "Odsyłacz do Pomocy nie zadziałał",
		"contentLocale": "Język treści",
		"pdf": "PDF",
		"oldPassword": "Stare hasło",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Ułatwienia dostępu",
		"manageLogging": "Rejestrowanie",
		"loggingConfigurationSlideoutA11yLabel": "Konfiguracja rejestrowania",
		"communityErrorTitle": "Odsyłacz do Społeczności nie zadziałał",
		"companionApps": "Aplikacje towarzyszące",
		"setHomeLabel": "Ustaw (bieżący widok) jako stronę główną",
		"metricsExportTask": "Nowy eksport",
		"csvRestricted": "CSV (z ograniczeniami)",
		"newFeaturesErrorMessage": "Spróbuj ponownie.  Jeśli problem będzie się powtarzał, skontaktuj się z administratorem.",
		"contributor": "Contributor",
		"showAll": "Pokaż wszystko",
		"logging_active": "Rejestrowanie jest włączone:",
		"html": "HTML",
		"profileAndSettings": "Profil i ustawienia",
		"baseTextDirection": "Podstawowy kierunek tekstu",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Hasło",
		"invalidEmail": "Wprowadź poprawny adres e-mail",
		"credentialCreateSuccess": "Pomyślnie utworzono dane uwierzytelniające",
		"settings": "Ustawienia",
		"restrictedFormatSelected": "Nie masz możliwości uruchamiania raportów w tym formacie, ale możesz uzyskiwać dostęp do raportów zapisanych w tym formacie.",
		"usageDataDeletionConfirmation": "Usunięcie danych o używaniu skasuje wyniki uczenia sztucznej inteligencji.  Czy na pewno chcesz usunąć dane o używaniu?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Wyświetl szczegóły",
		"deleteUsageData": "Usuń dane o używaniu:",
		"showPassword": "Pokaż hasło",
		"AILearning_config_title": "Uczenie sztucznej inteligencji",
		"myPreferencesSlideoutLabel": "Profil i ustawienia",
		"passWordChangeSuccess": "Pomyślnie zmieniono hasło",
		"logging_level": "Poziom rejestrowania:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Spróbuj ponownie.  Jeśli problem będzie się powtarzał, skontaktuj się z administratorem.",
		"cancel": "Anuluj",
		"shareSetError": "Aby wykonać tę czynność, należy zamknąć i z powrotem otworzyć ten widok.",
		"passwordNotMatch": "Niestety, hasła są niezgodne",
		"xml": "XML",
		"xmlRestricted": "XML (z ograniczeniami)",
		"openMenu": "Otwórz menu",
		"closeMenu": 'Zamknij menu'
});